import { get, handleError } from "@/lib/http-adapter";
import { AppearanceSettings } from "@/state/appearance-settings";

interface AppearanceSettingsResponse {
  appearance_setting: AppearanceSettings;
}

export const getAppearanceSettings = async (): Promise<AppearanceSettings> => {
  try {
    const response = await get<AppearanceSettingsResponse>(
      "/public/appearance-settings"
    );
    return response?.appearance_setting;
  } catch (error) {
    handleError(error);
  }
};
